export const ISSUES_PAGE_CONSTANTS = {
	TITLE: 'Issues Across Sessions',
	DESCRIPTION: 'View a full list of issues or focus on unique issues. The table updates live.',
	BACK_BUTTON_TEXT: 'Back to Web Dashboard'
};
